import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Grid,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { useEffect, useState } from "react";
import RxOrderDetail from "../../components/RxOrderDetail";
import { ProductDetail } from "../../components/RxOrderDetail/RxOrderDetail";
import RxPaper from "../../components/RxPaper";
import RxTypography from "../../components/RxTypography";
import api from "../../config/AxiosConfig";
import { DistributorObject } from "../sale/SalePage";
import styles from "./OrderHistoryPage.module.css";

export interface OrderHistoryObject {
	orderNumber: number;
	orderDate: string;
	totalPrice: number;
	distributor: DistributorObject;
	products: ProductDetail[];
}

const OrderDetail = () => {
	const [purchaseHistoryObjectList, setPurchaseHistoryObjectList] = useState<
		OrderHistoryObject[]
	>([]);

	const getPurchaseHistory = async () => {
		await api
			.get("/1/basket/order-history")
			.then((response: OrderHistoryObject[]) => {
				setPurchaseHistoryObjectList(response);
			});
	};

	useEffect(() => {
		getPurchaseHistory();
	}, []); //eslint-disable-line

	return (
		<RxPaper className={styles.mainPaper}>
			<Grid container>
				<Grid item xs={12} sm={12}>
					<RxTypography variant="h5" label="Siparişlerim" />
				</Grid>
				<Grid item xs={12} sm={12}>
					<hr />
				</Grid>
				<Grid item xs={12} sm={12}>
					<Grid container spacing={1}>
						{purchaseHistoryObjectList.map(
							(order: OrderHistoryObject) => {
								return (
									<Grid item xs={12} sm={12}>
										<Grid
											container
											spacing={2}
											className={styles.topGrid}
										>
											<Grid item xs={3} sm={3}>
												<RxTypography
													className={styles.title}
													label="SİPARİŞ TARİHİ"
												/>
												<RxTypography
													className={styles.titleDesc}
													label={order.orderDate}
												/>
											</Grid>
											<Grid item xs={3} sm={3}>
												<RxTypography
													className={styles.title}
													label="TOPLAM"
												/>
												<RxTypography
													className={styles.titleDesc}
													label={
														order.totalPrice.toFixed(2) + " TL"
													}
												/>
											</Grid>
											<Grid item xs={3} sm={3}>
												<RxTypography
													className={styles.title}
													label="BAYİ"
												/>
												<RxTypography
													className={styles.titleDesc}
													label={order.distributor?.name}
												/>
											</Grid>
											<Grid
												item
												xs={3}
												sm={3}
												className={styles.orderNo}
											>
												<RxTypography
													className={styles.title}
													label="SİPARİŞ NO"
												/>
												<RxTypography
													className={styles.titleDesc}
													label={order.orderNumber}
												/>
											</Grid>
											<Grid
												item
												xs={12}
												sm={12}
												className={styles.bottomGrid}
											>
												<Accordion>
													<AccordionSummary
														expandIcon={<ExpandMore />}
													>
														<RxTypography
															variant="subtitle1"
															align="center"
															className={styles.orderTitle}
															label={"Sipariş Detayı"}
														/>
													</AccordionSummary>
													<AccordionDetails>
														<RxOrderDetail
															totalPrice={order.totalPrice}
															tableHeadClassName={
																styles.tableHeadBackground
															}
															values={order.products}
														/>
													</AccordionDetails>
												</Accordion>
											</Grid>
										</Grid>
									</Grid>
								);
							}
						)}
					</Grid>
				</Grid>
			</Grid>
		</RxPaper>
	);
};
export default OrderDetail;
